import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import netlifyIdentity from "netlify-identity-widget";
import "./dashboard.css";

const DASHBOARD_URL_ENDPOINT = "/.netlify/functions/dashboard-url";

function Dashboard() {
  const [user] = useState(() => netlifyIdentity.currentUser());
  const [status, setStatus] = useState("loading");
  const [dashboardUrl, setDashboardUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user) return;

    let cancelled = false;

    fetch(DASHBOARD_URL_ENDPOINT, {
      headers: {
        Authorization: `Bearer ${user.token.access_token}`,
      },
    })
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || "Failed to load dashboard");
        return data;
      })
      .then((data) => {
        if (cancelled) return;
        setDashboardUrl(data.url);
        setStatus("success");
        window.open(data.url, "_blank");
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message);
        setStatus("error");
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  if (!user) {
    return (
      <section className="dashboard__prompt">
        <Container>
          <h1 className="dashboard__title">Coaching Dashboard</h1>
          <p className="dashboard__subtitle">
            Please log in from the Members Area to view your coaching dashboard.
          </p>
        </Container>
      </section>
    );
  }

  if (status === "loading") {
    return (
      <section className="dashboard__prompt">
        <Container>
          <p className="dashboard__status">Loading your dashboard…</p>
        </Container>
      </section>
    );
  }

  if (status === "error") {
    return (
      <section className="dashboard__prompt">
        <Container>
          <h1 className="dashboard__title">Coaching Dashboard</h1>
          <p className="dashboard__status dashboard__status--error">{error}</p>
        </Container>
      </section>
    );
  }

  return (
    <section className="dashboard__prompt">
      <Container>
        <h1 className="dashboard__title">Coaching Dashboard</h1>
        <p className="dashboard__subtitle">
          Your coaching dashboard has been opened in a new tab.
        </p>
        <p className="dashboard__subtitle">
          If it didn't open,{" "}
          <a
            href={dashboardUrl}
            target="_blank"
            rel="noreferrer"
            className="dashboard__link"
          >
            click here to open it
          </a>
          .
        </p>
      </Container>
    </section>
  );
}

export default Dashboard;
